<div class="container">
    <div class="row">
    	<div class="col-9">
        	<img class="mt-2" src="assets/img/logos/logo.png" alt="Transforma" width="200" height="auto">
        </div>
        <div class="col-2">
        	<button class="btn btn-outline-secondary mt-4" (click)="goBack()">< Back</button>
        </div>
    </div>
</div>